const EVENT_NAMES = Object.freeze({
  OPENED: 'kenect-text-feature:opened',
  CLOSED: 'kenect-text-feature:closed',
});

const Events = {
  Opened: new Event(EVENT_NAMES.OPENED),
  Closed: new Event(EVENT_NAMES.CLOSED),
};

export { EVENT_NAMES, Events };
